import { Injectable } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { CommunicationService } from 'src/app/services/communication.service';
import { filter } from 'rxjs/operators';
import { UrlSegments } from 'src/app/jurisdiction/jurisdiction.constants';
import { RegepOrderProcess } from '../entities/regep-order-process';
import { EegEnergyProducer } from '../entities/regep-eeg-energy-producer';

@Injectable({
  providedIn: 'root',
})
export class RegepOrderProcessService {
  private orderProcessSubject = new ReplaySubject<RegepOrderProcess>();
  private hasCustomerAddedDataSubject = new Subject<boolean>();

  constructor(private communicationService: CommunicationService) {}

  public orderProcess$ = this.orderProcessSubject.asObservable();
  public hasCustomerAddedData$ = this.hasCustomerAddedDataSubject.asObservable();

  public loadOrderProcess(applicationId: number) {
    this.communicationService
      .getData<RegepOrderProcess>(`${UrlSegments.RegepOrderProcessByApplication}${applicationId}`)
      .pipe(filter(orderProcess => !!orderProcess))
      .subscribe(orderProcess => {
        this.orderProcessSubject.next(orderProcess);
        this.hasCustomerAddedDataSubject.next(orderProcess.customerAddedData);
        return;
      });
  }

  public engineeringOpenIssue(orderProcessId: number): Observable<any> {
    return this.communicationService.postData(UrlSegments.RegepEngineeringOpenIssue.replace(':id', orderProcessId.toString()), {});
  }

  public engineeringUpdateRequest(orderProcessId: number): Observable<any> {
    return this.communicationService.postData(UrlSegments.RegepEngineeringUpdateRequest.replace(':id', orderProcessId.toString()), {});
  }

  public engineeringOk(orderProcessId: number): Observable<any> {
    return this.communicationService.postData(UrlSegments.RegepEngineeringOk.replace(':id', orderProcessId.toString()), {});
  }

  public saveEegEnergyProducers(orderProcessId: number, eegEnergyProducers: EegEnergyProducer[]): Observable<any> {
    return this.communicationService.postData(
      UrlSegments.RegepSaveEegEnergyProducers.replace(':id', orderProcessId.toString()),
      eegEnergyProducers
    );
  }

  public customerDataAdded(orderProcessId: number): Observable<any> {
    return this.communicationService.postData(UrlSegments.RegepCustomerDataAdded.replace(':id', orderProcessId.toString()), {});
  }

  public regulationsOpenIssue(orderProcessId: number): Observable<any> {
    return this.communicationService.postData(UrlSegments.RegepRegulationsOpenIssue.replace(':id', orderProcessId.toString()), {});
  }

  public regulationsUpdateRequest(orderProcessId: number): Observable<any> {
    return this.communicationService.postData(UrlSegments.RegepRegulationsUpdateRequest.replace(':id', orderProcessId.toString()), {});
  }

  public regulationsOk(orderProcessId: number): Observable<any> {
    return this.communicationService.postData(UrlSegments.RegepRegulationsOk.replace(':id', orderProcessId.toString()), {});
  }

  public approveRequest(orderProcessId: number): Observable<any> {
    return this.communicationService.postData(UrlSegments.RegepApproveRequest.replace(':id', orderProcessId.toString()), {});
  }

  public denyRequest(orderProcessId: number): Observable<RegepOrderProcess> {
    return this.communicationService.postData(UrlSegments.RegepDenyRequest.replace(':id', orderProcessId.toString()), {});
  }

  public withdrawRequest(orderProcessId: number): Observable<RegepOrderProcess> {
    return this.communicationService.postData(UrlSegments.RegepWithdrawRequest.replace(':id', orderProcessId.toString()), {});
  }

  public withdrawAndCopyRequest(orderProcessId: number, applicationId: number): Observable<any> {
    return this.communicationService.postData(
      UrlSegments.RegepWithdrawAndCopyRequest.replace(':id', orderProcessId.toString()).replace(':applicationId', applicationId.toString()),
      {}
    );
  }
}
